import * as React from 'react';

import { WalkScoreViewModel } from 'src/common/models';

import { UitkIcon } from 'uitk-react-icons';
import { UitkLayoutColumnsNoBreak } from 'uitk-react-layout-columns';

import { WalkScore } from 'components/infosite/whats-around/internals/walk-score';

interface NearbyListProps {
  outerClass?: string;
  title?: string;
  category?: string;
  accessibleCategory?: string;
  walkScoreModel?: WalkScoreViewModel;
}

export const NearbyList: React.FunctionComponent<NearbyListProps> = ({
  title,
  outerClass,
  category,
  accessibleCategory,
  walkScoreModel,
  children
}) => {
  if (!title) {
    return null;
  }

  return (
    <UitkLayoutColumnsNoBreak>
      <div className={outerClass}>
        <>
          <div className="uitk-flex uitk-flex-row">
            {category && (
              <UitkIcon
                id={`${category}__heading-icon`}
                name={category}
                title={accessibleCategory || null}
                className="all-r-margin-three"
              />
            )}
            <div>
              <div className="uitk-flex uitk-flex-justify-content-space-between uitk-flex-align-items-flex-end">
                <h4 className="uitk-type-heading-500">{title}</h4>
              </div>
              <WalkScore model={walkScoreModel} />
            </div>
          </div>
          {children}
        </>
      </div>
    </UitkLayoutColumnsNoBreak>
  );
};

NearbyList.displayName = 'NearbyList';
